import { useAuthQuery } from "@bn/api";
import { getCurrencies, CurrencyParams } from "@api/v1/methods";
import { GET_CURRENCIES_KEY } from "../../cacheKeys";

export const useGetCurrencies = (params: CurrencyParams) =>
  useAuthQuery(
    [GET_CURRENCIES_KEY, params],
    ({ token }) => getCurrencies(token, params),
    {
      staleTime: Infinity,
    }
  );
